import React from "react";

function systemRequirements() {
  return (
    <div className="sys_requirementBlock">
      <h4>Operating System Versions</h4>
      <ul>
        <li className="active">
          Windows 8, Windows 8.1, Windows 10, Windows 11, <br></br>
          Windows Server 2012, Windows Server 2012 R2, Windows Server 2016,
          Windows Server 2019, Windows Server 2022, Windows Server 2025
        </li>
      </ul>
      <h4>File System</h4>
      <ul>
        <li className="active">NTFS formatted volumes</li>
      </ul>
      <h4>Disk Partitions Styles</h4>
      <ul>
        <li className="active">MBR, GPT</li>
      </ul>
    </div>
  );
}

export default systemRequirements;
